/**
 * Clerk publishable-key helpers for Create React App.
 *
 * Social login is optional: when the key is missing, Auth falls back to
 * email/password only (existing Drivenow flow).
 */

export const CLERK_PUBLISHABLE_KEY =
  process.env.REACT_APP_CLERK_PUBLISHABLE_KEY?.trim() || "";

export function isClerkEnabled(): boolean {
  return CLERK_PUBLISHABLE_KEY.length > 0;
}
